import api from '@/apis'
import { API_PREFIX } from '@/constants'
import type { CreateSealedOrderResponse, PaymentMethodId, PaymentMethodType } from '@/payment/types'

/**
 * 상품 주문 신청 (밀봉비닐 포함).
 *
 * POST /product-orders — 백엔드 표준 endpoint. apidog 명세:
 *  - quantity: 1~3개
 *  - method.id: 정기결제(CARD/ACCOUNT)는 paymentMethodId, 단건결제(KAKAOPAY/NAVERPAY)는 null
 *  - method.type: 결제수단 종류
 *
 * 응답에 paymentId 즉시 포함 — 별도 GET /orders/{id} 호출 불필요.
 * 카카오 단건결제일 때만 응답에 redirectURL 포함 (다른 결제수단은 미포함).
 */
export interface PostSealedOrderBody {
  quantity: number
  method: {
    id: PaymentMethodId | null
    type: PaymentMethodType
  }
}

export const apiPostSealedOrder = async (body: PostSealedOrderBody): Promise<CreateSealedOrderResponse> => {
  return api.post(`${API_PREFIX.ORDER}/product-orders`, body)
}
